import { convertRestIdToEwsId } from 'owa-identifiers';
import { generatePath, useNavigate, useParams } from 'mini-react-router-dom';
import { getMailItemFromItemId } from 'owa-mail-store/lib/store/selectors/getMailItemFromItemId';
import { isFeatureEnabled } from 'owa-feature-flags';
import { joinPath, type MailRoutes } from 'mini-routes';
import { lazyLoadItem } from 'mini-mail-load-conversation';
import { lazyReplyToMessage } from 'mini-mail-compose-actions-mail';
import { logCoreUsage } from 'owa-analytics';
import { REPLY_ACTION_FROM_NOTIFICATION } from 'mini-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { REPLY_ACTION_FROM_NOTIFICATION_BEGIN } from 'mini-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { REPLY_ACTION_FROM_NOTIFICATION_FAILED } from 'mini-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { useEffect } from 'react';
import type Message from 'owa-service/lib/contract/Message';

export const MailPushNotificationComposeRouteHandler = () => {
    const params = useParams() as {
        itemId: string;
        immutableItemId: string;
    };
    const navigate = useNavigate();

    useEffect(() => {
        const initialize = async () => {
            try {
                const { itemId: rawItemId, immutableItemId: rawImmutableItemId } = params;
                // If we get restIds, we need to convert them to ewsIds. If they are already ewsIds, the following conversion will be a no-op.
                const itemId = convertRestIdToEwsId(rawItemId);
                const immutableItemId = convertRestIdToEwsId(rawImmutableItemId);
                logCoreUsage(REPLY_ACTION_FROM_NOTIFICATION_BEGIN, {});
                const effectiveItemId = isFeatureEnabled('fwk-immutable-ids')
                    ? immutableItemId
                    : itemId;

                let message = getMailItemFromItemId(effectiveItemId) as Message;
                if (!message) {
                    const loadItem = await lazyLoadItem.import();
                    message = (await loadItem(effectiveItemId)) as Message;
                }

                const onOpenCompose = (composeItemId: string) => {
                    navigate(generatePath('/inbox'), { replace: true });
                    navigate(
                        generatePath(joinPath('/inbox', 'compose/:composeId'), {
                            composeId: encodeURIComponent(composeItemId),
                        })
                    );
                };
                lazyReplyToMessage(message, 'Notification', false /*isReplyAll*/, onOpenCompose);
                logCoreUsage(REPLY_ACTION_FROM_NOTIFICATION, {});
            } catch (error) {
                logCoreUsage(REPLY_ACTION_FROM_NOTIFICATION_FAILED, { error: error });
            }
        };
        initialize();
    }, [params, navigate]);

    return null;
};
